export const PLAYER_CARD_EFFECT_GAIN_ARMOR = {
  copy: 'You gain %1 armor from your equipment',
  direction: 'outbound',
};

export const PLAYER_CARD_EFFECT_CURE = {
  copy: 'You cure yourself of all negative ailments',
  direction: 'outbound',
};

export const PLAYER_CARD_EFFECT_GAIN_HP = {
  copy: 'You restore %1 HP',
  direction: 'outbound',
};

export const PLAYER_CARD_EFFECT_GAIN_MP = {
  copy: 'You restore %1 MP',
  direction: 'outbound',
};

export const PLAYER_CARD_EFFECT_CREATURE_RESIST = {
  copy: 'Enemy %1 resisted your %2 attack',
  direction: 'outbound',
};

export const PLAYER_CARD_EFFECT_REDRAW = {
  copy: 'You re-draw your current hand',
  direction: 'outbound',
};

export const PLAYER_CARD_EFFECT_DAMAGE = {
  copy: 'Your attack on enemy %1 lands for %2 damage',
  direction: 'outbound',
};

export const PLAYER_CARD_EFFECT_BREAK_CREATURE_ARMOR = {
  copy: 'You break the armor of enemy %1',
  direction: 'outbound',
};

export const PLAYER_CARD_EFFECT_APPLY_BURN = {
  copy: 'You burn enemy %1 for %2 turns',
  direction: 'outbound',
};

export const PLAYER_CARD_EFFECT_APPLY_FREEZE = {
  copy: 'You freeze enemy %1 for %2 turns',
  direction: 'outbound',
};

export const PLAYER_CARD_EFFECT_APPLY_PARALYSIS = {
  copy: 'You paralyse enemy %1 for %2 turns',
  direction: 'outbound',
};

export const PLAYER_CARD_EFFECT_APPLY_POISON = {
  copy: 'You poison enemy %1 for %2 turns',
  direction: 'outbound',
};
